module.exports = {"title":"Connect to a POS Terminal","description":"Please select your POS Terminal to connect and complete the transaction.","ok":"OK"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/StripeDeviceSelect/locales/en.json
// module id = 1328
// module chunks = 0